import { cn } from '@/lib/utils';
import * as React from 'react';

type InputProps = React.ComponentProps<'input'> & {
    error?: boolean;
    errorMsg?: string;
    variant?: 'default' | 'outline';
    wrapperClassName?: string;
};

function Input({
    className,
    wrapperClassName = '',
    type,
    error = false,
    errorMsg = '',
    variant = 'default',
    ...props
}: InputProps) {
    const baseStyles =
        'file:text-foreground placeholder:text-black selection:bg-primary selection:text-primary-foreground border-input flex w-full min-w-0 rounded-md border bg-transparent px-3 py-1  shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';

    const variantStyles = {
        default: 'dark:bg-input/30',
        outline:
            'bg-background border-y-1 border-x-0 rounded-none border-black bg-transparent text-black h-full lg:px-5 lg:py-4',
    };

    const placeholderStyles =
        'lg:text-[18px] text-[16px] 2xl:text-[20px] abc-italic ';

    const focusStyles =
        'focus-visible:border-y-2 focus-visible:ring-transparent focus-visible:ring-[0px]';
    const errorStyles = error ? ' ' : '';

    return (
        <div className={cn('w-full', wrapperClassName)}>
            <input
                type={type}
                data-slot="input"
                className={cn(
                    baseStyles,
                    variantStyles[variant],
                    placeholderStyles,
                    focusStyles,
                    errorStyles,
                    className,
                )}
                aria-invalid={error}
                {...props}
            />
            {error && errorMsg && (
                <p className="text-destructive absolute text-sm">{errorMsg}</p>
            )}
        </div>
    );
}

export { Input };
